import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import { PurchaseMethodsModel } from 'commons-vehicle/PurchaseMethods/index.js';

import AmountLineItem from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.jsx';
import AmountLineItemWithIcon from 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItemWithIcon.jsx';

const CashPurchase = ({ purchaseMethods }) => {
    const purchaseMethodAmounts = purchaseMethods.getSelectedPurchaseMethodAmounts();
    const purchaseMethodDeliveryAmounts = purchaseMethods.getSelectedPurchaseMethodDeliveryAmounts();
    const accessoriesOptionsPackages = purchaseMethods.getSelectedOptions();

    const {
        cashDown,
        discounts,
        exteriorColour,
        freightPDI,
        interiorColour,
        lien,
        modelTrim,
        options,
        otherFees,
        protections,
        rebates,
        taxAndDuty,
        taxes,
        tradeIn,
    } = purchaseMethodAmounts;

    const allInPrice =
        modelTrim +
        exteriorColour +
        interiorColour +
        options +
        freightPDI +
        otherFees +
        taxAndDuty +
        protections -
        discounts;

    const totalPriceBeforeTaxes =
        modelTrim +
        exteriorColour +
        interiorColour +
        options +
        freightPDI +
        otherFees +
        taxAndDuty +
        protections -
        (discounts + tradeIn);

    const totalPriceAfterTaxes = totalPriceBeforeTaxes + taxes + lien - (rebates + cashDown);

    const { deliveryCashDown, deliveryFees, deliveryTaxes, deposit, upfrontPayment } = purchaseMethodDeliveryAmounts;

    const totalDueAtDelivery = totalPriceAfterTaxes + deliveryFees + deliveryTaxes + deposit;
    const protectionsWithIcons = accessoriesOptionsPackages.map((protectionPackage) => {
        return (
            <AmountLineItemWithIcon
                label={protectionPackage.description}
                amount={protectionPackage.retail}
                icon="plus"
            />
        );
    });

    return (
        <div className="CashPurchaseSummary">
            <div className="vehicle__salePrice">
                <AmountLineItemWithIcon
                    label={LocaleService.t('SUMMARY.TOTAL_PRICE_BEFORE_TAXES')}
                    amount={allInPrice - protections}
                    icon="review"
                />
                {protectionsWithIcons}
            </div>

            <ul className="SidebarSummary__listingAmount">
                <h3 className="sr-title">{LocaleService.t('SUMMARY.TRANSACTION_TITLE_CASH_PURCHASE')}</h3>
                <AmountLineItem label={LocaleService.t('SUMMARY.SELLING_PRICE')} amount={modelTrim} />
                <AmountLineItem label={LocaleService.t('SUMMARY.DISCOUNTS')} amount={discounts} />
                <AmountLineItem label={LocaleService.t('SUMMARY.EXTERIOR_COLOUR')} amount={exteriorColour} />
                <AmountLineItem label={LocaleService.t('SUMMARY.OPTIONS')} amount={interiorColour + options} />
                <AmountLineItem label={LocaleService.t('SUMMARY.FREIGHT_PDI')} amount={freightPDI} />
                <AmountLineItem label={LocaleService.t('SUMMARY.TAXES_AND_DUTIES')} amount={taxAndDuty} />
                <AmountLineItem label={LocaleService.t('SUMMARY.OTHER_FEES')} amount={otherFees} />
                <AmountLineItem label={LocaleService.t('SUMMARY.PROTECTIONS')} amount={protections} />
                <AmountLineItem label={LocaleService.t('SUMMARY.TRADE_IN')} amount={tradeIn} />
                <AmountLineItem
                    label={LocaleService.t('SUMMARY.TOTAL_PRICE_BEFORE_TAXES')}
                    amount={totalPriceBeforeTaxes}
                />
                <AmountLineItem label={LocaleService.t('SUMMARY.TAXES')} amount={taxes} />
                <AmountLineItem label={LocaleService.t('SUMMARY.LIEN')} amount={lien} />
                <AmountLineItem label={LocaleService.t('SUMMARY.REBATES')} amount={rebates} />
                <AmountLineItem label={LocaleService.t('SUMMARY.CASHDOWN')} amount={cashDown} />
                <AmountLineItem
                    label={LocaleService.t('SUMMARY.TOTAL_PRICE_AFTER_TAXES')}
                    amount={totalPriceAfterTaxes}
                />
            </ul>
            <div className="deliver-infos">
                <h3 className="sr-title">{LocaleService.t('SUMMARY.SIDEBAR_DELIVERY_TITLE')}</h3>
                <ul className="SidebarSummary__listingAmount">
                    <AmountLineItem
                        label={LocaleService.t('SUMMARY.TOTAL_PRICE_AFTER_TAXES')}
                        amount={totalPriceAfterTaxes}
                    />
                    <AmountLineItem label={LocaleService.t('SUMMARY.OTHER_FEES')} amount={deliveryFees} />
                    <AmountLineItem label={LocaleService.t('SUMMARY.CASHDOWN')} amount={deliveryCashDown} />
                    <AmountLineItem label={LocaleService.t('SUMMARY.TAXES')} amount={deliveryTaxes} />
                    <AmountLineItem label={LocaleService.t('SUMMARY.UPFRON_PAYMENT')} amount={upfrontPayment} />
                    <AmountLineItem label={LocaleService.t('SUMMARY.DEPOSIT')} amount={deposit} />
                    {totalDueAtDelivery >= 0 ? (
                        <AmountLineItem
                            label={LocaleService.t('SUMMARY.TOTAL_DUE_AT_DELIVERY')}
                            amount={totalDueAtDelivery}
                            showZero
                        />
                    ) : (
                        <AmountLineItem
                            label={LocaleService.t('SUMMARY.TOTAL_REFUND_AT_DELIVERY')}
                            amount={-1 * totalDueAtDelivery}
                        />
                    )}
                </ul>
            </div>
        </div>
    );
};

CashPurchase.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsModel).isRequired,
};

CashPurchase.displayName = 'CashPurchase';

export default CashPurchase;



// WEBPACK FOOTER //
// ./src/Quote/components/TransactionSummary/CashPurchase/CashPurchase.jsx